import { useState } from 'react';
import { Link } from 'react-router-dom';
import ProblemReasonBox from './ProblemReasonBox';

function CounselingSecColSubChildUnRegister({
  editModeEnabled,
  providerId = 0,
  // soapId = 0,
  patientId = 0,
  visitId = 0,
  onReasonUpdate = () => {},
  data,
  subData,
  checkBoxData,
  checkboxRef,
  handleCheckBoxLable,
  handleCheckBoxChange,
  handleRemoveSubChild,
  moduleName,
  allData,
  both,
}) {
  const [curPblmReason, setCurPblmReason] = useState(false);
  const [popupData, setPopUpData] = useState([]);
  const [editSave, setEditSave] = useState(false);
  const handleOpenPopup = (lbl, reson, dxId, providerId, reasonTxtId) => {
    setCurPblmReason(true);
    setPopUpData([lbl, reson, dxId, providerId, reasonTxtId]);
  };

  return (
    <div className="sec-col-ht">
      <div className="sec-col-parnt-cont">
        {both &&
          subData[2] &&
          subData[2]?.map((childData, k) => (
            <div
              key={k}
              className={`chld-rw qcontent-line-break ${moduleName}MasterSubChildData_${data[3]}_${subData[0]}`}
              id={`${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`}
              data-search-term={childData?.child_texte}
            >
              <span className="">
                <input
                  type="checkbox"
                  className={`${moduleName}SubChildDataList_${data[3]}_${subData[0]}`}
                  id={`${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`}
                  checked={
                    checkBoxData &&
                    checkBoxData[
                      `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`
                    ]
                  }
                  ref={(el) =>
                    (checkboxRef.current[
                      `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`
                    ] = el)
                  }
                  onChange={handleCheckBoxChange}
                />
              </span>
              <span className="chld-rw-txt">
                <span
                  className=""
                  id={`${moduleName}SubChildDataList_${data[3]}_${subData[0]}_${childData?.child_id}`}
                  onClick={() =>
                    handleCheckBoxLable(
                      `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${childData?.child_id}`
                    )
                  }
                >
                  {childData?.child_texte}
                </span>
                <span
                  id={`${moduleName}diagReason_${data[3]}_${subData[0]}_${childData?.child_id}`}
                  style={{ display: 'none' }}
                >{`${
                  allData?.reasonArr && allData?.reasonArr[childData?.child_id]
                }`}</span>
                <span className="clear7 med-label">
                  {allData?.reasonArr && (
                    <div className="chld-rw-txt">
                      {allData?.reasonArr[childData?.child_id] &&
                      allData?.reasonArr[childData?.child_id].length > 20 ? (
                        <>
                          {allData?.reasonArr[childData?.child_id].slice(0, 20)}
                          {'...'}
                          <span
                            className="smart-tag-name"
                            onClick={() =>
                              handleOpenPopup(
                                childData?.child_texte,
                                allData?.reasonArr[childData?.child_id]
                              )
                            }
                          >
                            see more
                          </span>
                        </>
                      ) : (
                        allData?.reasonArr[childData?.child_id]
                      )}
                      {curPblmReason && (
                        <ProblemReasonBox
                          reasonNote={popupData}
                          onCancelReason={() => setCurPblmReason(false)}
                        />
                      )}
                    </div>
                  )}
                </span>
              </span>
              {editModeEnabled && (
                <>
                  <span
                    className="hide"
                    style={{ width: '10%' }}
                    onClick={() =>
                      handleRemoveSubChild(
                        `${data[3]}_${subData[0]}_${childData?.child_id}`
                      )
                    }
                  >
                    <Link>&#10007;</Link>
                  </span>
                  <span className="hide">
                    <Link>&#10007;</Link>
                  </span>
                </>
              )}
            </div>
          ))}
        {allData &&
          allData?.map((val, s) => (
            <div
              key={s}
              className={`chld-rw qcontent-line-break ${moduleName}MasterSubChildData_${data[3]}_${subData[0]}`}
              id={`${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${val?.id}`}
              data-search-term={val?.label}
            >
              <span className="">
                <input
                  type="checkbox"
                  className={`${moduleName}SubChildDataList_${data[3]}_${subData[0]}`}
                  id={`${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${val?.id}`}
                  checked={
                    checkBoxData &&
                    checkBoxData[
                      `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${val?.id}`
                    ]
                  }
                  ref={(el) =>
                    (checkboxRef.current[
                      `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${val?.id}`
                    ] = el)
                  }
                  onChange={handleCheckBoxChange}
                />
              </span>
              <span className="" style={{ width: '90%' }}>
                <span
                  className="chld-rw-txt"
                  id={`${moduleName}SubChildDataList_${data[3]}_${subData[0]}_${val?.id}`}
                  onClick={() =>
                    handleCheckBoxLable(
                      `${moduleName}SubChildDataListInpt_${data[3]}_${subData[0]}_${val?.id}`
                    )
                  }
                >
                  {val?.label}
                </span>
                <span
                  id={`${moduleName}diagReason_${data[3]}_${subData[0]}_${val?.id}`}
                  style={{ display: 'none' }}
                >
                  {val?.reason && `${val?.reason}`}
                </span>
                <span className="chld-rw-txt">
                  {val?.reason && (
                    <div className="chld-rw-txt">
                      {val?.reason.length > 20 ? (
                        <>
                          {val?.reason.slice(0, 20)}
                          {'...'}
                          <span
                            className="smart-tag-name"
                            onClick={() => {
                              handleOpenPopup(val?.label, val?.reason);
                              setEditSave(false);
                            }}
                          >
                            see more
                          </span>
                        </>
                      ) : (
                        val?.reason
                      )}
                    </div>
                  )}
                </span>
                {/* {curPblmReason && (
                  <ProblemReasonBox
                    soapId={soapId}
                    reasonNote={popupData}
                    onReasonUpdate={onReasonUpdate}
                    editSave={editSave}
                    onCancelReason={() => setCurPblmReason(false)}
                  />
                )} */}
              </span>
              <span
                className="hide"
                style={{ width: '10%' }}
                onClick={() =>
                  handleRemoveSubChild(`${data[3]}_${subData[0]}_${val?.id}`)
                }
              >
                <Link>&#10007;</Link>
              </span>
              <span
                className={`${data[4] !== 'diagnosis' ? 'hide' : ''}`}
                onClick={() => {
                  handleOpenPopup(
                    val?.label,
                    val?.reason,
                    val.id,
                    providerId,
                    `${data[3]}_${subData[0]}_${val?.id}`
                  );
                  setEditSave(true);
                }}
              >
                <Link>&#9998;</Link>
              </span>
            </div>
          ))}
        {curPblmReason && (
          <ProblemReasonBox
            // soapId={soapId}
            patientId={patientId}
            visitId={visitId}
            reasonNote={popupData}
            onReasonUpdate={onReasonUpdate}
            editSave={editSave}
            onCancelReason={() => setCurPblmReason(false)}
          />
        )}
      </div>
    </div>
  );
}

export default CounselingSecColSubChildUnRegister;
